import React from 'react';
import { Alert } from "@material-tailwind/react";
import LogDashboard from './logs/LogDashboard';
import LogBrowser from './logs/LogBrowser';
const { rootUrl } = require('../../config/config');

const LogViewer = () => {
    const token = localStorage.getItem('authToken') || 'default-token';

    return (
        <div className="p-6">
            {/* Performance Notice */}
            <Alert color="blue" className="mb-6">
                <div className="font-medium">Performance Notice</div>
                <div className="text-sm mt-1">
                    Log viewer is optimized for performance. Only the most recent logs are displayed.
                    Use filters to narrow your search for better performance.
                </div>
            </Alert>

            {/* Dashboard Overview */}
            <LogDashboard rootUrl={rootUrl} token={token} />

            {/* Log Browser */}
            <LogBrowser rootUrl={rootUrl} token={token} />
        </div>
    );
};

export default LogViewer;
